export default __webpack_public_path__ + "src/images/btn_enter_system/3-6a60ac.png";